import React from 'react'
import {Router} from 'react-router-dom'
import DocumentTitle from 'react-document-title'
import {createBrowserHistory} from 'history'
import {MuiThemeProvider, createMuiTheme} from 'material-ui/styles'
import './App.css'
import 'material-design-icons/iconfont/material-icons.css'
import 'material-design-icons/iconfont/MaterialIcons-Regular.woff2'
import 'material-design-icons/iconfont/MaterialIcons-Regular.woff'
import 'material-design-icons/iconfont/MaterialIcons-Regular.ttf'
import 'typeface-raleway'
import 'typeface-lato'

import {Routes} from './components'

const theme = createMuiTheme(
  {
    palette: {
      hero: "rgb(45, 107, 252)",
      footer: "rgb(253, 203, 91)",
      // footer: "rgb(191, 240, 139)",
      contrast: "rgb(255, 255, 255)",
      normal: "rgb(119, 119, 119)",
      card: "rgb(255, 255, 255)",
      muted: "#eee",
      emphasis: "rgb(253, 203, 91)",
      labels: [
        "rgb(230, 84, 96)",
        "rgb(226, 100, 203)",
        "rgb(96, 224, 159)",
        "rgb(132, 218, 46)",
      ],
    },
    layout: {
      contentWidth: 1024,
      heroTotalHeight: 560,
      cardFloatUp: 120,
    },
    typography: {
      fontFamily: "'Raleway'",
    },
  }
)

const history = createBrowserHistory()

history.listen((location, action) => {
  console.log('history', action, location.pathname, location.state)
  window.analytics.page()
})




class App extends React.Component {
  render() {
    return (
      <DocumentTitle title="Carefol.io">
        <Router history={history}>
          <MuiThemeProvider theme={theme}>
              <Routes/>
          </MuiThemeProvider>
        </Router>
      </DocumentTitle>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js